var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import InputSelect from './InputSelect';
import { FormGroupLabel } from '../FormGroupLabel';
var InputSelectVertical = /** @class */ (function (_super) {
    __extends(InputSelectVertical, _super);
    function InputSelectVertical() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputSelectVertical.prototype.render = function () {
        var _a = this.props, label = _a.label, className = _a.className, isRequired = _a.isRequired, feedback = _a.feedback, defaultValue = _a.defaultValue, isDisabled = _a.isDisabled, isLoading = _a.isLoading, isClearable = _a.isClearable, isSearchable = _a.isSearchable, options = _a.options, placeholder = _a.placeholder, name = _a.name, onChange = _a.onChange, autoFocus = _a.autoFocus, value = _a.value, isRounded = _a.isRounded, helpText = _a.helpText, saveLSKeyId = _a.saveLSKeyId, size = _a.size, id = _a.id, instanceId = _a.instanceId, isOptionDisabled = _a.isOptionDisabled;
        return (React.createElement(FormGroupLabel, { feedback: feedback, isRounded: isRounded, label: label, isRequired: isRequired, helpText: helpText, className: className, id: id },
            React.createElement(InputSelect, { autoFocus: autoFocus, onChange: onChange, defaultValue: defaultValue, isDisabled: isDisabled, isLoading: isLoading, isClearable: isClearable, isSearchable: isSearchable, name: name, options: options, placeholder: placeholder, value: value, size: size, isRounded: isRounded, saveLSKeyId: saveLSKeyId, instanceId: instanceId, id: 'i-' + (id || ''), isOptionDisabled: isOptionDisabled })));
    };
    return InputSelectVertical;
}(Component));
export default InputSelectVertical;
//# sourceMappingURL=InputSelectVertical.js.map